import { useAuthStore, useFeatureToggleStore, useUserSettingStore } from 'app/stores/StoreContext'
import { APPEARANCE_THEME_SETTING } from 'lib/theme'

/**
 * True once availability (the toggle, or the user being a super admin) and the saved preference are
 * both known. Acting earlier would apply, clear or save a theme from defaults the user never had.
 * Callers must be wrapped in `observer()`.
 */
export function useThemeReady(): boolean {
  const auth = useAuthStore()
  const toggleStore = useFeatureToggleStore()
  const settingStore = useUserSettingStore()
  return !auth.loading && toggleStore.loadSettled && APPEARANCE_THEME_SETTING in settingStore.settings
}
